import './query.less';
import React from 'react';
import * as R from 'ramda';
import { connect } from 'react-redux';
import { Form, Modal, Dropdown, Alert, Drawer, Timeline, Avatar, Tabs, Select, Input, Button, Layout, Menu, Icon, Row, Col, Table, Divider, Tooltip } from 'antd';
import QueryEditor from './QueryEditor';
import QueryResultsTable from './QueryResultsTable';
import { QUERY_COLOR } from '../entityColors';
import { fetchQueryResults } from '../../common/reducers/queryResultsReducer';
import { editQuery, renameQuery } from '../../common/reducers/queryReducer';
import TabContentHeader from '../TabContentHeader';
import tabHOC from '../tabHOC';
import RenameQueryModal from './RenameQueryModal';

const getDerivedQuery = R.memoize(
  (query = {}, draft = {}) => ({ ...query, ...draft }),
);

const getRevisions = R.memoize(
  (query = {}, draft = {}) => (
    Object.keys(draft)
    // Note: This only works because we don't store nested objects in any of the category props.
      .filter(key => JSON.stringify(draft[key]) === JSON.stringify(query[key]))
      .reduce((acc, key) => ({ ...acc, [key]: draft.value }), {})
  ),
);

const snippets = [
  {
    value: 'Where mediaId="***"',
    description: 'Find specific mediaId',
  },
  {
    value: 'SELECT mediaId, HITS () FROM media',
    description: 'Show me HITS for my query',
  },
  {
    value: 'SELECT * FROM media;',
    description: 'Get all fields from all media',
  },
  {
    value: 'SELECT HITS(), mediaId, topics, totalSilenceRatio, metadata, length FROM media',
    description: 'Get common fields from all media',
  },
  {
    value: 'Where metadata.uploadversion="1" AND dateCreated > "2020-05-27T00:00:00.000+0000"',
    description: 'Get all fields including hits() from all media',
    append: true,
  }
];

const mapStateToProps = (state, ownProps) => {
  const connection = state.connection.byId[state.connection['/window'].ids[0]];
  const keyWindow = ownProps.keyWindow;
  const metaQuery = R.path(['query', keyWindow], state);
  const metaResults = R.path(['queryResults', keyWindow], state);
  const id = R.path(['ids', 0], metaQuery);
  const query = R.path(['query', 'byId', id], state);
  const draft = R.path(['query', 'draftsById', id], state);
  const queryResults = R.path(['queryResults', 'byId', keyWindow], state);
  /*
  const derivedQuery = getDerivedQuery(query, draft);
  const revisions = getRevisions(query, draft);
  const connection = state.connection.byId[state.connection['/window'].ids[0]];
  */
  return ({
    keyWindow,
    connection,
    query: draft || query,
    queryResults: queryResults || {},
    errors: R.path(['queryResults', keyWindow, 'errors'], state),
    isLoading: metaResults && metaResults.isLoading,
    /*
    revisions,
    isLoading: metaResults && metaResults.isLoading,
    isEditing: !!draft,
    hasChanges: !!Object.keys(revisions).length,
    */
  });
};

const mapDispatchToProps = (dispatch) => {
  return ({
    runQuery: (keyWindow, query) => dispatch(fetchQueryResults(keyWindow, query)),
    onEdit: (id, props) => {
      dispatch(editQuery(id, props));
    },
    onRenameQuery: (keyWindow, id, query) => dispatch(renameQuery(keyWindow, id, query)),
  });
};

class Query extends React.Component {

  columns = [
    {
      title: 'mediaId',
      width: 80,
      dataIndex: 0,
      key: 'mediaId',
      align: 'center',
      fixed: 'left',
      render: value => (
        <a onClick={this.handleShowPlayer}>{value} <Icon type="select" /></a>
      ),
    },
  ];

  handleMenuAction = ({ key }) => {
    const { keyWindow, query, onRenameQuery } = this.props;
    switch (key) {
      case 'rename': {
        let formRef = {};
        Modal.confirm({
          title: 'Rename your query',
          content: (
           <RenameQueryModal onReady={(ref) => { formRef = ref; }} />
          ),
          okText: 'Rename',
          okType: 'primary',
          cancelText: 'Cancel',
          iconType: 'edit',
          onOk: () => {
            return new Promise((resolve, reject) => {
              formRef.validateFields((err, values) => {
                if (!err) {
                  resolve(onRenameQuery(keyWindow, query.id, { ...query, ...values }));
                } else {
                  reject();
                }
              });
            });
          },
        });
        break;
      }
      default:
    }
  };

  handleRun = (vbql) => {
    const { keyWindow, runQuery, query } = this.props;
    runQuery(keyWindow, { ...query, vbql });
  };

  handleEdit = (vbql) => {
    const { onEdit, query } = this.props;

    onEdit(query.id, { ...query, vbql });
  };

  handleCodeSnippetAction = ({ key }) => {
    const snippet = _.get(snippets, `[${key}]`, {});
    const append = !!snippet.append;
    const { query } = this.props;
    const value = append ? `${query.vbql} ${snippet.value}`: snippet.value;
    if (value) {
      this.handleEdit(value);
    }
  };

  render() {
    const { connection, query, queryResults, isLoading, errors } = this.props;

    const menu = (
      <Menu onClick={this.handleMenuAction}>
        <Menu.Item key="rename">Rename</Menu.Item>
      </Menu>
    );

    const codeSnippets = (
      <Menu onClick={this.handleCodeSnippetAction}>
        {snippets.map((x, i) => (<Menu.Item key={i} title={x.description}>{x.append && '...'}{x.value}</Menu.Item>))}
      </Menu>
    );

    return (
      <div>
        <TabContentHeader
          title={query.name ? query.name : `Query ${query.id}`}
          icon="code-o"
          color={QUERY_COLOR}
          actions={
            <>
            <Dropdown overlay={codeSnippets}>
              <Button style={{ marginRight: '10px' }}>
                Code Snippets <Icon type="down" />
              </Button>
            </Dropdown>
            <Dropdown overlay={menu}>
              <Button>
                Actions <Icon type="down" />
              </Button>
            </Dropdown>
            </>
          }
        />
        <Row style={{ margin: '32px', flexFlow: 'column' }} type="flex">
          <Col>
            <QueryEditor
              onRun={this.handleRun}
              onChange={this.handleEdit}
              running={isLoading}
              query={query}
            />
          </Col>
          {!errors && queryResults.data && (
            <Col>
              <QueryResultsTable
                meta={queryResults.meta}
                columns={queryResults.columns}
                data={queryResults.data}
                id={queryResults.id}
                connection={connection}
                loading={isLoading}
              />
            </Col>
          )}
          {errors && (
            <Col>
              <Alert
                style={{ marginTop: '8px' }}
                message="Received Errors:"
                description={errors.map(error => (
                  error.error
                    ? (
                      <div style={{ color: 'red' }}>
                        {error.error}
                      </div>
                    ) : (
                      <div style={{ color: 'red' }}>
                        {`${error.type}: ${error.message} (line ${error.line}, pos ${error.position})`}
                      </div>
                    )
                ))}
                type="error"
                showIcon
              />
            </Col>
          )}
        </Row>
      </div>
    );
  }
}

export default tabHOC('query')(connect(mapStateToProps, mapDispatchToProps)(Query));
